import { createAction, createReducer, on, props } from '@ngrx/store';

export const SET_SESSIONREFRESH_TYPE = 'SET_SESSIONREFRESH';
export const SET_SESSIONREFRESH = createAction(SET_SESSIONREFRESH_TYPE, props<{ state: boolean, avoidPersistence?: boolean }>());

const initialState = false;

const _sessionRefreshReducer = createReducer(
  initialState,
  on(SET_SESSIONREFRESH, (actualState, { state }) => (state === true || state === false) ? state : actualState),
);

export function sessionRefreshReducer(state, action) {
  return _sessionRefreshReducer(state, action);
}
